module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/featuresComparatore/features.component.scss
// module id = ./src/app/featuresComparatore/features.component.scss
// module chunks = main